const getDefaultState = () => {
  return {
    fitSkillGraphView: false,
    revokeTenantUserSkill: false,
    updateTenantUserSkillNodes: false,
    updateTenantUserSkillEdges: false,
  };
};


const triggers = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    triggerFitSkillGraphView (state) {
      state.fitSkillGraphView = !state.fitSkillGraphView;
    },
    triggerRevokeTenantUserSkill (state) {
      state.revokeTenantUserSkill = !state.revokeTenantUserSkill;
    },
    triggerUpdateTenantUserSkillNodes (state) {
      state.updateTenantUserSkillNodes = !state.updateTenantUserSkillNodes;
    },
    triggerTenantUserSkillEdges (state) {
      state.updateTenantUserSkillEdges = !state.updateTenantUserSkillEdges;
    },
  },
};

export default triggers;
